import styles from './ButtonLink.module.css';

interface Props {
  href: string;
  title: string;
  target?: string;
  disabled?: boolean;
}

export const ButtonLink = ({
  href,
  title,
  target = '_self',
  disabled = false,
}: Props) => {
  return (
    <div className={styles.buttonLink}>
      <a href={href} target={target} data-disabled={disabled}>
        {title}
      </a>
    </div>
  );
};
